module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/setting-section-description/setting-section-description.scss
// module id = ./web/modern/components/settings/common/setting-section-description/setting-section-description.scss
// module chunks = 0